import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import useMediaQuery from "@mui/material/useMediaQuery";

const list = Array.from({ length: 6 });

function DesktopInboundSkeleton() {
  return (
    <Box p={2}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Skeleton animation="wave" width={100} />
              </TableCell>
              <TableCell>
                <Skeleton animation="wave" width={120} />
              </TableCell>
              <TableCell>
                <Skeleton animation="wave" width={110} />
              </TableCell>
              <TableCell>
                <Skeleton animation="wave" width={70} />
              </TableCell>
              <TableCell align="right">
                <Skeleton animation="wave" width={80} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton animation="wave" width={120} />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" width={180} />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" width={200} />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" width={80} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton animation="wave" width={100} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

function MobileInboundSkeleton() {
  return (
    <Box>
      {list.map((_, index) => (
        <Card key={index} sx={{ mb: 1.5 }}>
          <CardContent sx={{ "&:last-child": { pb: 2 } }}>
            <Box mb={2}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Skeleton variant="text" width="40%" height={24} />
                <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
              </Box>
              <Box mt={1}>
                <Skeleton variant="text" width="60%" height={20} />
              </Box>
            </Box>
            <Divider sx={{ mb: 1 }} />
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Skeleton variant="circular" width={32} height={32} />
              <Box display="flex" gap={1}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="circular" width={32} height={32} />
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

export default function InboundTableSkeleton() {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));

  return isMobile ? <MobileInboundSkeleton /> : <DesktopInboundSkeleton />;
}
